export default __webpack_public_path__ + "static/media/FA580168-EDEC-4E1D-B1A7-A258297331D4_1_105_c.e6d05fc8.jpeg";